import "./app/trustedTypes";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App } from "./App";
import { captureAcquisitionParams } from "./shared/lib/acquisition";
import "./styles.css";
import "./i18n";

// Must run before App.tsx's history.replaceState strips the query string off the URL.
captureAcquisitionParams();

const client = new QueryClient();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={client}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
);
